import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {

    fetchAccount({ commit } , model) {
        return new Promise((resolve, reject) => {
            ajax
              .get(`Credits/api/AccountsQuery/get_all-last-level-of-accounts`)
              .then((r) => {
                resolve(r.data);
              })
              .catch((e) => reject(e));
          });
    },
    searchParty({ commit, dispatch },  name ) {
      return new Promise((resolve, reject) => {
        ajax
          .get(`Credits/api/PartiesQuery/get-all-by/${name}`)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    fetchAccountsByname({ commit } , model) {
      return new Promise((resolve, reject) => {
          ajax
            .get(`Credits/api/AccountsQuery/get_all-last-level-of-accounts?name=${model}`)
            .then((r) => {
              resolve(r.data);
            })
            .catch((e) => reject(e));
        });
      },
    fetchChildsData({ commit } , id) {
        return new Promise((resolve, reject) => {
            ajax
              .get(`Credits/api/CostCentersQuery/get-all-account-reference-infos/${id}`)
              .then((r) => {
                resolve(r.data);
              })
              .catch((e) => reject(e));
          });
    },
    fetchChildsDataCostTitle({ commit } , id) {
        return new Promise((resolve, reject) => {
            ajax
              .get(`Credits/api/CostTitleQuery/get-all-account-reference-infos/${id}`)
              .then((r) => {
                resolve(r.data);
              })
              .catch((e) => reject(e));
          });
    },
    fetchAllSubsideryAndDetailsAccount({ commit }) {
      return new Promise((resolve, reject) => {
          ajax
            .get(`Credits/api/AccountsQuery/get_all-subsidiary-and-detail-accounts`)
            .then((r) => {
              resolve(r.data);
            })
            .catch((e) => reject(e));
        });
  },
  fetchAllFloatingAccountByParent({ commit },id) {
    return new Promise((resolve, reject) => {
        ajax
          .get(`Credits/api/FloatingAccountsQuery/get-all-accounts-by/${id}`)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
  },
    fetchAllCostTitleByParent({ commit },id) {
      return new Promise((resolve, reject) => {
          ajax
            .get(`Credits/api/PartiesQuery/get-all-cost-titles-by/${id}`)
            .then((r) => {
              resolve(r.data);
            })
            .catch((e) => reject(e));
        });
  },
    create({ commit, dispatch }, model) {
      return ajax.post("Credits/api/CostCenters", model).then(() => {
        
      });
    },
    createCostTitle({ commit, dispatch }, model) {
      return ajax.post("Credits/api/CostTitle", model).then(() => {
        
      });
    },

    delete({ commit, dispatch }, id) {
      return ajax
        .delete(
          "Credits/api/CostCenters",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {
          //dispatch('fetch')
        });
    },
    createAccountParty({ commit, dispatch }, model) {
      return ajax.put("Credits/api/CostCenters/assign-account-reference", model).then(() => {
        
      });
    },
    createAccountPartyCostTitle({ commit, dispatch }, model) {
      return ajax.put("Credits/api/CostTitle/assign-account-reference", model).then(() => {
        
      });
    },
    
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
